import { supportedBrowsersRegExp } from 'virtual:supported-browsers';

/**
 * Whether the current browser is within client-web's support policy (.browserslistrc).
 *
 * The regex is generated at build time from the same browserslist config that drives the
 * Vite build target, so this reflects exactly what the shipped bundle was compiled for.
 *
 * Note: this is only a signal for browsers that load and run the bundle but sit below our
 * policy. Browsers too old to even parse the module bundle are handled separately by the
 * static fallback in index.html.
 */
export default function isBrowserSupported(
  userAgent: string = window.navigator.userAgent,
): boolean {
  return supportedBrowsersRegExp.test(userAgent);
}
